import editEquipment from "./update";

const headerLabel = "Cadastrando equipamento";

export default {
  getDataKey: "",
  storeDataKey: "",
  submitDataKey: "CREATE_EQUIPMENT",
  headerLabel,
  finishedDataButton: editEquipment.finishedDataButton,
  fields: editEquipment.fields,
};
